export const prefixDataAttr = "data-prefix-parent";

export const prefixDataProp = {
  [prefixDataAttr]: true,
};
